import { render, staticRenderFns } from "./QuestionChoices.vue?vue&type=template&id=554569c1&scoped=true&"
import script from "./QuestionChoices.vue?vue&type=script&lang=js&"
export * from "./QuestionChoices.vue?vue&type=script&lang=js&"
import style0 from "./QuestionChoices.vue?vue&type=style&index=0&id=554569c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554569c1",
  null
  
)

export default component.exports